<template>
  <div class="app-tokenhandler">
    <SimonModal
      :is-visible="showInfoModal"
      @hide="showInfoModal = false"
    >
      <template v-slot:modalTitle>
        <h3>{{ infoModalTitle }}</h3>
      </template>
      <div v-html="infoModalContent"></div>
    </SimonModal>
    <SimonCollapse ref="collapse" :customAriaLabel="getSlotText('customAriaLabel')">
      <template #headline><slot name="lblHeadline">Lorem ipsum dolor sit.</slot></template>
      <template #content>
        <div class="token--form" v-if="showForm">
          <b-form id="token-form" :novalidate="true" @submit.prevent="checkToken()">
            <div class="form-row">
              <LabeledTextInput name="token" :model.sync="token" :formatter="formatToken">
                <template v-slot:txtPlaceholder><slot name="lblHeadline">Lorem ipsum dolor sit.</slot></template>
                <template v-for="slot in possibleChildSlotsFor('Token')" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
                <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
              </LabeledTextInput>
              <button type="button" class="outline" @click.prevent.stop="checkToken()" :disabled="!token || loading"><slot name="lblCheckToken">Lorem</slot></button>
            </div>
          </b-form>
        </div>
        <div class="token--redeemed" :id="token.code" v-for="token in redeemedTokens" :key="token.type">
          <img aria-hidden="true" class="icon-check" src="files/flash/images/svg-icons/check-small.svg" height="20" width="20"/>
          <span>{{token.code}} <slot name="lblRedeemed"></slot></span>
          <div class="action-buttons">
          <button class="text" @click="openInfoModal(token)"><img class="icon-info" src="files/flash/images/svg-icons/info-icon.svg" alt="Mehr Informationen" height="20" width="20"></button>
          <button class="text" @click="deleteToken(token.type, token.code)"><img class="icon-remove" src="files/flash/images/svg-icons/trashbin.svg" alt="Code entfernen" height="20" width="17"></button>
          </div>
        </div>
      </template>
    </SimonCollapse>
  </div>
</template>

<script>

import voucherConfig from '@/mixins/voucherConfig'
import trackingHandler from '@/mixins/trackingHandler'
import SimonCollapse from '@/components/generic/SimonCollapse.vue'
import LabeledTextInput from '@/components/forms/LabeledTextInput.vue'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'TokenHandler',
  components: {
    LabeledTextInput,
    SimonCollapse,
    SimonModal
  },
  mixins: [
    voucherConfig,
    trackingHandler
  ],
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  data () {
    return {
      loading: false,
      token: null,
      showInfoModal: false,
      infoModalTitle: null,
      infoModalContent: null,
      kkCheckVoucherCallback: null
    }
  },
  mounted () {
    const _this = this
    window.kk = window.kk || {}
    if (typeof window.kk.addVoucherCode === 'undefined') {
      window.kk.addVoucherCode = async (code, callback = null) => {
        _this.checkToken(code)
        if (typeof callback === 'function') {
          _this.kkCheckVoucherCallback = callback
        }
      }
    }
    const URLParams = new URLSearchParams(window.location.search)
    const voucherCodeFromUrl = URLParams.get('promoCode') || null
    if (voucherCodeFromUrl) {
      URLParams.delete('promoCode')
      let paramString = ''
      if (URLParams.size > 0) {
        paramString = '?' + URLParams.toString()
      }
      window.history.replaceState({}, document.title, window.location.pathname + paramString)
      this.checkToken(voucherCodeFromUrl)
    }
    if (this.voucherCode || this.kwkToken) {
      this.openCollapse()
    }
  },
  computed: {
    targetPromotions () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/targetPromotions']
    },
    kwkToken () {
      if (this.$store.getters['checkoutv2/' + this.process + '/_cart/hideKwkToken']) {
        return null
      }
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/kwkToken']
    },
    kwkPromotions () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/kwkPromotions']
    },
    voucherCode () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/voucherCode']
    },
    voucherPromotions () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/voucherPromotions']
    },
    redeemedTokens () {
      const ret = []
      if (this.voucherCode) ret.push({ type: 'Voucher', code: this.voucherCode, content: this.voucherInfoOverlayContent })
      if (this.kwkToken) ret.push({ type: 'KwkToken', code: this.kwkToken, content: this.getSlotText('txtKwkInfoOverlay', 'kwk') })
      return ret
    },
    showForm: function () {
      return this.voucherCode === null || (this.$store.getters['checkoutv2/' + this.process + '/_cart/kwkToken'] === null && this.process === 'ordering')
    },
    voucherInfoOverlayContent: function () {
      if (this.voucherPromotions && this.voucherPromotions[0] && this.voucherPromotions[0].promotionId) {
        return this.getSlotText('txtCouponRedeemedModalInfo' + this.getSlotIdForVoucherPromo(this.voucherPromotions[0].promotionId))
      }
      return ''
    }
  },
  methods: {
    formatToken (token) {
      return token ? token.replace(/\s/g, '') : ''
    },
    // Set focus manually to token input, info button or delete button
    setFocusManually (elementId, process) {
      const el = document.getElementById(elementId)

      if (!el) {
        // If element is not found, focus on the token input
        document.getElementById('token')?.focus()
        return
      }

      // Determine the button to focus on (info or delete button)
      const btn = process === 'checkToken'
        ? el.querySelector('button')
        : el.querySelector('button:last-of-type')

      btn?.focus()
    },
    async checkToken (token = this.token) {
      if (!token || token === '') {
        return
      }

      this.startLoader()
      this.loading = true
      this.clearToasts()

      try {
        const response = await this.$store.dispatch(`checkoutv2/${this.process}/_cart/queryCart`, { token })

        let addedPromos = this.voucherPromotions
        if (response.tokenType === 'voucher') {
          this.successToast(this.getSlotText('txtVoucherCodeRedeemed', 'voucher'), () => {
            this.setFocusManually(token, 'checkToken')
          })
        } else {
          this.successToast(this.getSlotText('txtKwkCodeRedeemed', 'kwk'), () => {
            this.setFocusManually(token, 'checkToken')
          })
          addedPromos = this.kwkPromotions
        }

        let trackingName = ''
        addedPromos.forEach(promo => {
          trackingName += promo.name + ','
        })

        this.trackData('voucher', {
          voucher_action: 'apply',
          voucher_code: token,
          voucher_name: trackingName.slice(0, -1)
        })

        this.token = null
        if (typeof this.kkCheckVoucherCallback === 'function') {
          this.kkCheckVoucherCallback(true)
          this.kkCheckVoucherCallback = null
        }

        this.openCollapse()
      } catch (error) {
        if (typeof this.kkCheckVoucherCallback === 'function') {
          this.kkCheckVoucherCallback(false)
          this.kkCheckVoucherCallback = null
        }

        this.errorToast(this.getErrorMessage(error), () => {
          this.setFocusManually()
        })

        this.triggerErrorTracking(error, this.token)
      } finally {
        this.loading = false
        this.stopLoader()
      }
    },
    openCollapse () {
      this.$refs.collapse.open()
    },
    openInfoModal (token) {
      this.infoModalTitle = token.code
      this.infoModalContent = token.content
      this.showInfoModal = true
      this.trackData('information', {
        information_action: 'reveal',
        information_name: token.type.toLowerCase() + 'info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      })
    },
    async deleteToken (type, code) {
      this.startLoader()
      this.loading = true
      this.clearToasts()
      let trackingName = ''
      let trackingCode = ''

      if (type === 'Voucher') {
        trackingCode = this.voucherCode
        this.voucherPromotions.forEach(promo => {
          trackingName += promo.name + ','
        })
      } else {
        trackingCode = this.kwkToken
        this.kwkPromotions.forEach(promo => {
          trackingName += promo.name + ','
        })
      }

      try {
        await this.$store.dispatch(`checkoutv2/${this.process}/_cart/remove${type}`, {})

        if (type === 'Voucher') {
          this.successToast(this.getSlotText('txtVoucherCodeRemoved', 'voucher'), () => {
            this.setFocusManually()
          })
        } else {
          this.successToast(this.getSlotText('txtKwkCodeRemoved', 'kwk'), () => {
            this.setFocusManually()
          })
        }

        this.trackData('voucher', {
          voucher_action: 'remove',
          voucher_code: trackingCode,
          voucher_name: trackingName.slice(0, -1)
        })
      } catch (error) {
        this.errorToast(this.getErrorMessage(error), () => {
          this.setFocusManually(code, 'deleteToken')
        })
        this.triggerErrorTracking(error)
      } finally {
        this.loading = false
        this.stopLoader()
      }
    }
  }
}
</script>
